import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Box from '@classify/react-core-components/Box';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import { translate } from '@openclassrooms/translations';
import { FacebookIcon, InstagramIcon, LinkedInIcon, TwitterIcon, YoutubeIcon } from '../../../social/components';
import { FACEBOOK_COLOR, INSTAGRAM_COLOR, LINKEDIN_COLOR, TWITTER_COLOR, YOUTUBE_COLOR } from '../../../social/services';
function SocialButton(t0) {
  const $ = _c(8);
  const {
    title,
    url,
    children,
    color
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: "text.onMain"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== color) {
    t2 = {
      flexShrink: 0,
      boxSizing: "border-box",
      height: 40,
      width: 40,
      border: 1,
      borderColor: "text.onMain",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      py: 1,
      px: 1.25,
      transition: "background 0.1s ease",
      "&:visited": t1,
      "&:hover": {
        color: "text.onContrasted",
        borderColor: "rgb(0 0 0 / 0%)",
        background: color,
        backgroundOrigin: "border-box"
      }
    };
    $[1] = color;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2 || $[5] !== title || $[6] !== url) {
    t3 = <Box component="a" href={url} title={title} target="_blank" rel="noopener noreferrer" sx={t2}>{children}</Box>;
    $[3] = children;
    $[4] = t2;
    $[5] = title;
    $[6] = url;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export default function FooterSocialButtons() {
  const $ = _c(22);
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      width: "100%",
      flexWrap: "wrap",
      columnGap: "3%",
      rowGap: "8px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== getLocalisationConfig) {
    t1 = getLocalisationConfig("social.facebook");
    $[1] = getLocalisationConfig;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = String(t1);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FacebookIcon />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <SocialButton url={t2} title="Facebook" color={FACEBOOK_COLOR}>{t3}</SocialButton>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== getLocalisationConfig) {
    t5 = getLocalisationConfig("social.twitterX");
    $[6] = getLocalisationConfig;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = String(t5);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <TwitterIcon title={translate("global.twitter_account")} />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <SocialButton url={t6} title="X" color={TWITTER_COLOR}>{t7}</SocialButton>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SocialButton url="https://www.linkedin.com/company/openclassrooms" title="LinkedIn" color={LINKEDIN_COLOR}><LinkedInIcon /></SocialButton>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SocialButton url="https://instagram.com/openclassrooms" title="Instagram" color={INSTAGRAM_COLOR}><InstagramIcon /></SocialButton>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== getLocalisationConfig) {
    t11 = getLocalisationConfig("openclassrooms.youtube.url");
    $[13] = getLocalisationConfig;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = String(t11);
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <YoutubeIcon />;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t12) {
    t14 = <SocialButton url={t12} title="YouTube" color={YOUTUBE_COLOR}>{t13}</SocialButton>;
    $[16] = t12;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t14 || $[19] !== t4 || $[20] !== t8) {
    t15 = <Box sx={t0}>{t4}{t8}{t9}{t10}{t14}</Box>;
    $[18] = t14;
    $[19] = t4;
    $[20] = t8;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  return t15;
}